(function () {
  'use strict';

  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts || false); };
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (v) { return v == null ? '' : v; };

  function routeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return '/';
  }

  /* ---------------------------------------------------------------- Gallery */
  function initGallery(root) {
    var viewport = $('[data-gallery-viewport]', root);
    if (!viewport) return;

    var panels = $$('[data-gallery-panel]', viewport);
    var thumbs = $$('[data-gallery-thumb]', root);
    var dots = $$('[data-gallery-dot]', root);

    function mark(i) {
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    }

    function goTo(i) {
      var panel = panels[i];
      if (!panel) return;
      viewport.scrollTo({ left: panel.offsetLeft - viewport.offsetLeft, behavior: 'smooth' });
      mark(i);
    }

    thumbs.forEach(function (t, i) { on(t, 'click', function () { goTo(i); }); });
    dots.forEach(function (d, i) { on(d, 'click', function () { goTo(i); }); });

    var tick;
    on(viewport, 'scroll', function () {
      window.clearTimeout(tick);
      tick = window.setTimeout(function () {
        var mid = viewport.scrollLeft + viewport.clientWidth / 2;
        var best = 0, bestD = Infinity;
        panels.forEach(function (s, i) {
          var c = s.offsetLeft - viewport.offsetLeft + s.clientWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        mark(best);
      }, 70);
    }, { passive: true });

    mark(0);
  }

  /* --------------------------------------------------------------- Quantity */
  function clampQty(input) {
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
    var step = parseInt(input.getAttribute('step') || '1', 10) || 1;
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    v = Math.max(min, Math.min(max, v));
    var offset = Math.round((v - min) / step) * step + min;
    input.value = Math.max(min, Math.min(max, offset));
  }

  function initQty(root) {
    $$('[data-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(input.getAttribute('step') || '1', 10) || 1;
          var dir = parseInt(btn.getAttribute('data-qty-step'), 10);
          input.value = (parseInt(input.value, 10) || 0) + dir * step;
          clampQty(input);
        });
      });
      on(input, 'change', function () { clampQty(input); });
    });
  }

  /* --------------------------------------------------------------- Add-ons */
  function initAddons(root) {
    $$('[data-addon-toggle]', root).forEach(function (btn) {
      on(btn, 'click', function () {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        var onLabel = btn.getAttribute('data-label-on');
        var offLabel = btn.getAttribute('data-label-off');
        if (onLabel && offLabel) btn.textContent = pressed ? offLabel : onLabel;
      });
    });
  }

  /* -------------------------------------------------------- Variant picker */
  function initVariants(root) {
    var dataEl = $('[data-variant-data]', root);
    var picker = $('[data-variant-picker]', root);
    var idInput = $('[data-variant-id-input]', root);
    if (!dataEl || !idInput) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var needsName = $('[data-needs-name]', root);
    if (needsName) {
      needsName.setAttribute('name', 'id');
      needsName.removeAttribute('data-needs-name');
    }

    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare]', root);
    var saveEl = $('[data-save-badge]', root);
    var submit = $('[data-buy-submit]', root);
    var skuWrap = $('[data-sku]', root);
    var skuVal = $('[data-sku-value]', root);
    var stockWrap = $('[data-stock]', root);
    var stockText = $('[data-stock-text]', root);
    var qtyInput = $('[data-qty] input', root);

    var stockTemplate = stockText ? stockText.textContent : '';
    var threshold = parseInt(root.getAttribute('data-low-stock-threshold') || '10', 10);

    function selectedOptions() {
      if (!picker) return null;
      var groups = {};
      $$('input[type="radio"]', picker).forEach(function (r) {
        if (r.checked) groups[r.getAttribute('data-option-position')] = r.value;
      });
      var out = [];
      Object.keys(groups).sort(function (a, b) { return a - b; }).forEach(function (k) { out.push(groups[k]); });
      return out;
    }

    function findVariant(opts) {
      if (!opts) return null;
      for (var i = 0; i < variants.length; i++) {
        var vo = variants[i].options || [];
        var hit = vo.length === opts.length;
        for (var j = 0; hit && j < opts.length; j++) if (vo[j] !== opts[j]) hit = false;
        if (hit) return variants[i];
      }
      return null;
    }

    /* Disable option values that lead to no purchasable variant, given the
       other currently-selected values. Mirrors Shopify's own picker behaviour. */
    function refreshAvailability() {
      if (!picker) return;
      var current = selectedOptions();
      $$('fieldset', picker).forEach(function (fs, gi) {
        $$('input[type="radio"]', fs).forEach(function (r) {
          var probe = current.slice();
          probe[gi] = r.value;
          var match = findVariant(probe);
          var ok = !!(match && match.available);
          r.disabled = !ok;
        });
      });
    }

    function apply(variant) {
      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-label-sold-out') || '';
        }
        return;
      }

      idInput.value = variant.id;

      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.on_sale) { compareEl.hidden = false; compareEl.textContent = money(variant.compare_at_price); }
        else compareEl.hidden = true;
      }
      if (saveEl) saveEl.hidden = !variant.on_sale;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? (submit.getAttribute('data-label-buy') || '')
          : (submit.getAttribute('data-label-sold-out') || '');
      }

      if (skuWrap) {
        if (variant.sku) { skuWrap.hidden = false; if (skuVal) skuVal.textContent = variant.sku; }
        else skuWrap.hidden = true;
      }

      if (stockWrap && stockText) {
        var tracked = variant.inventory_management && variant.inventory_policy === 'deny';
        var low = tracked && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold;
        stockWrap.hidden = !low;
        if (low) stockText.textContent = stockTemplate.replace('[count]', variant.inventory_quantity);
      }

      if (qtyInput) {
        qtyInput.min = variant.quantity_min || 1;
        qtyInput.step = variant.quantity_increment || 1;
        if (variant.quantity_max) qtyInput.max = variant.quantity_max;
        else qtyInput.removeAttribute('max');
        clampQty(qtyInput);
      }

      document.dispatchEvent(new CustomEvent('labbox:variant-changed', { detail: variant }));

      if (window.history && window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      on(picker, 'change', function (e) {
        if (e.target.type !== 'radio') return;
        var variant = findVariant(selectedOptions());
        refreshAvailability();
        apply(variant);
      });
      refreshAvailability();
    }

    /* Let the pre-order timeline drive the picker, when the merchant maps a
       batch to a real option value. */
    document.addEventListener('labbox:select-option', function (e) {
      if (!picker || !e.detail || !e.detail.value) return;
      var hit = $$('input[type="radio"]', picker).filter(function (r) {
        return r.value.toLowerCase() === String(e.detail.value).toLowerCase() && !r.disabled;
      })[0];
      if (!hit) return;
      hit.checked = true;
      hit.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* --------------------------------------------------- Add to cart (+addons) */
  function initCartForm(root) {
    var form = $('[data-buy-form]', root);
    if (!form) return;
    var errorEl = $('[data-form-error]', root);

    on(form, 'submit', function (e) {
      var extras = $$('[data-addon-toggle][aria-pressed="true"]', root)
        .map(function (b) { return b.getAttribute('data-variant-id'); })
        .filter(Boolean);

      if (!extras.length) return;

      e.preventDefault();
      if (errorEl) errorEl.classList.remove('is-visible');

      var submit = $('[data-buy-submit]', form);
      var idle = submit ? submit.textContent : '';
      if (submit) {
        submit.disabled = true;
        var busy = submit.getAttribute('data-label-adding');
        if (busy) submit.textContent = busy;
      }

      var idField = $('[data-variant-id-input]', form) || $('[name="id"]', form);
      var qtyEl = $('[data-qty] input', root);
      var items = [{
        id: parseInt(idField.value, 10),
        quantity: parseInt(qtyEl ? qtyEl.value : '1', 10) || 1
      }];
      extras.forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: 1 }); });

      fetch(routeRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'cart');
          window.location.href = routeRoot() + 'cart';
        })
        .catch(function (err) {
          if (submit) { submit.disabled = false; submit.textContent = idle; }
          if (errorEl) {
            if (err && err.message && err.message !== 'cart') errorEl.textContent = err.message;
            errorEl.classList.add('is-visible');
            errorEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });
    });
  }

  /* ------------------------------------------------------------ Sticky bar */
  function initStickyBar() {
    var bar = $('[data-sticky-bar]');
    if (!bar) return;
    var anchor = document.getElementById(bar.getAttribute('data-anchor') || 'buy');
    if (!anchor) return;

    var show = function (v) { bar.classList.toggle('is-visible', v); };

    var priceEl = $('[data-sticky-price]', bar);
    var compareEl = $('[data-sticky-compare]', bar);
    document.addEventListener('labbox:variant-changed', function (e) {
      var v = e.detail;
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.hidden = !v.on_sale;
        if (v.on_sale) compareEl.textContent = v.compare_at_price;
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { show(!en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { rootMargin: '-40px 0px 0px 0px' }).observe(anchor);
    } else {
      on(window, 'scroll', function () { show(anchor.getBoundingClientRect().bottom < 40); }, { passive: true });
    }
  }

  /* --------------------------------------------------------- Mobile drawer */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    var open = $('[data-drawer-open]');
    if (!drawer || !open || typeof drawer.showModal !== 'function') return;

    on(open, 'click', function () {
      drawer.showModal();
      open.setAttribute('aria-expanded', 'true');
    });
    $$('[data-drawer-close]', drawer).forEach(function (b) {
      on(b, 'click', function () { drawer.close(); });
    });
    on(drawer, 'close', function () { open.setAttribute('aria-expanded', 'false'); });
    on(drawer, 'click', function (e) { if (e.target === drawer) drawer.close(); });
  }

  /* ----------------------------------------------------------- Video embed */
  function initVideo() {
    $$('[data-video-play]').forEach(function (btn) {
      on(btn, 'click', function () {
        var wrap = btn.closest('[data-video]');
        var url = wrap && wrap.getAttribute('data-video-url');
        if (!wrap || !url) return;
        var f = document.createElement('iframe');
        f.setAttribute('src', url + (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
        f.setAttribute('title', wrap.getAttribute('data-video-title') || 'Video');
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen', '');
        wrap.replaceChildren(f);
      });
    });
  }

  /* -------------------------------------------------------- Batch selector */
  function initBatch() {
    var group = $('[data-batch]');
    if (!group) return;
    $$('[data-batch-item]', group).forEach(function (btn) {
      on(btn, 'click', function () {
        if (btn.disabled) return;
        $$('[data-batch-item]', group).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');

        var note = btn.getAttribute('data-batch-note');
        if (note) $$('[data-batch-echo]').forEach(function (e) { e.textContent = note; });

        var optionValue = btn.getAttribute('data-option-value');
        if (optionValue) {
          document.dispatchEvent(new CustomEvent('labbox:select-option', { detail: { value: optionValue } }));
        }
      });
    });
  }

  /* ------------------------------------------------------------------ Boot */
  function boot() {
    if (document.querySelector('.lb-shell, .lb-header')) document.body.classList.add('lb-dark');

    $$('[data-buy-zone]').forEach(function (z) {
      initGallery(z); initQty(z); initAddons(z); initVariants(z); initCartForm(z);
    });
    initStickyBar();
    initDrawer();
    initVideo();
    initBatch();
  }

  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', boot);
  else boot();
})();
